export default __webpack_public_path__ + "static/img-merit03-4f0ee39d599b3e05b0ff9e21b76b7169.svg";